import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AccountCreationComponent } from '../../components';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TranslocoModule,
        MatIcon,
        AccountCreationComponent,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule
    ]
})
export class SignUpComponent {}
